// extracted by mini-css-extract-plugin
module.exports = {"favourite":"p_t"};